import axios from 'axios'
import store from 'store'
import { message } from 'antd';
import { getParam } from 'ruigu-utils';

const SUCCESS_CODE = 200;
const CONFIRM_CODE = 4002003;

// base request url
axios.defaults.baseURL = process.env.REACT_APP_API
// 超时时间：5s
axios.defaults.timeout = 10000
// 跨域请求不携带 cookie 凭证
axios.defaults.withCredentials = false

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (store.get('token')) {
      config.headers.Authorization = `bearer ${store.get('token')}`
    }
    return config;
  },
  error => Promise.error(error)
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    const { code } = (response.data || {})
    if (code === 401 || code === 40101) {
      window.localStorage.clear()

      if (getParam('system') != 'cs') {
        message.warning((response.data || {}).message || '用户身份失效或无法登录');
        setTimeout(() => {
          window.location.href = `${window.location.origin}/login`
        }, 1500)
      }

      return Promise.reject(response.data)
    }

    // eslint-disable-next-line no-constant-condition
    return response.status === SUCCESS_CODE && (response.data ? [SUCCESS_CODE, CONFIRM_CODE].includes(response.data.code) : true) ? Promise.resolve(response.data || response) : Promise.reject(response.data || response)
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * get请求
 * @param url 请求地址
 * @param params 请求参数
 * @param config 请求配置
 */
export async function get(url = '', params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      ...config
    }).then((res) => {
      if (res.code === SUCCESS_CODE || res) {
        resolve(res.data || res || {result: true})
      } else {
        reject({message: res.msg})
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * post请求
 * @param url api url
 * @param data data
 */
export async function post(url = '', data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then((res) => {
      if (res.code === SUCCESS_CODE) {
        resolve(res.data || {result: true})
      } else if (res.code === CONFIRM_CODE) {
        resolve(res)
      } else {
        reject({message: res.message})
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * put
 * @param url api url
 * @param data data
 */
export async function put(url = '', data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then((res) => {
      if (res.code === SUCCESS_CODE) {
        if (typeof res.data === 'string') {
          resolve({result: true, msg: res.data})
        } else {
          resolve(res.data || {result: true})
        }
      } else {
        if(res.msg){
          reject({message: res.msg})
        }
        else if(res.message){
          reject({message: res.message})
        }else{
          reject({message: res})
        }
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * delete请求
 * @param url 请求地址
 * @param params 请求参数
 * @param config 请求配置
 */
 export async function deleteReq(url = '', params = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params
    }).then((res) => {
      if (res.code === SUCCESS_CODE || res) {
        resolve(res.data || res || {result: true})
      } else {
        reject({message: res.msg})
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
